import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useApp } from '@context/AppContext';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_ID?.replace(/\/+$/, '');

export const GoogleAnalytics = () => {
  const location = useLocation();
  const { user, companyId, companyInfo, isAuthorized } = useApp();

  useEffect(() => {
    if (import.meta.env.PROD && GA_MEASUREMENT_ID) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
    }
  }, []);

  useEffect(() => {
    if (import.meta.env.PROD && GA_MEASUREMENT_ID) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
        title: document.title,
      });
    }
  }, [location]);

  useEffect(() => {
    if (import.meta.env.PROD && GA_MEASUREMENT_ID && isAuthorized && user) {
      // Set user properties for GA4
      ReactGA.gtag('set', {
        user_properties: {
          user_account: user.account,
          user_email: user.email,
          company_id: companyId,
          company_name: companyInfo?.publishName || '',
        },
      });
    }
  }, [user, companyId, companyInfo, isAuthorized]);

  return null;
};

export default GoogleAnalytics;
